import { Checkbox } from '@cian/ui-kit';
import * as React from 'react';

import { Filter } from '../common/Filter';
import { InlineFilter } from '../common/InlineFilter';
import { InlineFilterGroup } from '../common/InlineFilterGroup';

interface IOnlineBookingProps {
  value: boolean | null;
  onChange(value: boolean | null): void;
}

export const OnlineBooking: React.FC<IOnlineBookingProps> = ({ value, onChange }) => {
  return (
    <Filter id="advancedFilter_onlineBooking" label="Формат бронирования">
      <InlineFilterGroup>
        <InlineFilter>
          <Checkbox
            label="Мгновенное бронирование"
            checked={Boolean(value)}
            onChange={event => onChange(event.target.checked)}
          />
        </InlineFilter>
      </InlineFilterGroup>
    </Filter>
  );
};
